
import React from 'react';
import { useApi } from '../../context/ApiProvider';

export default function EditLibraryTemplateForm(props) {
    const { selectedTemplate, setSelectedTemplate, onError, onSuccess, onHide } = props;
    const api = useApi();

    if (!selectedTemplate) return null;

    function handleSaveTemplateTitle() {
        if (!selectedTemplate) return;

        if (selectedTemplate.name.trim() === "") {
            onHide();
            onError("Template title cannot be empty.");
            return;
        }

        api.put(`/library/rolfingtemplates/${selectedTemplate.ID}`, { ...selectedTemplate, name: selectedTemplate.name })
            .then(() => {
                onSuccess("Template updated successfully.");
            }).catch((err) => {
                console.error("Error updating template title:", err);
                onError("Failed to update template. Please try again later.");
            }).finally(() => {
                onHide();
                setTimeout(() => {
                    onSuccess("");
                    onError("");
                }, 5000);
            });
    }

    return (
        <div>
            <p>Edit the title and status of the template here:</p>
            <label htmlFor="templateName">Template Name:</label>
            <input type="text" id='templateName' className="formControl" value={selectedTemplate?.name} onChange={(e) => setSelectedTemplate({ ...selectedTemplate, name: e.target.value })} />
            <label htmlFor="templateStatus">Status:</label>
            <select id="templateStatus" className="formControl" value={selectedTemplate?.active ? "active" : "inactive"} onChange={(e) => setSelectedTemplate({ ...selectedTemplate, active: e.target.value === "active" })}>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
            </select>
            <button onClick={handleSaveTemplateTitle}>Save</button>
            <p className='meta'><i className="fa fa-info-circle" aria-hidden="true" /> An active template is selectable by others in Rolf Admin, while inactive templates are hidden.</p>
        </div>
    )
}